import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CasesService, CatalogService, SpinnerService } from '@core';
import { CasesResult, CasesType, CatalogItem, FilteredCase } from '@shared';
import { INglDatatableSort } from 'ng-lightning';
import { Observable } from 'rxjs';
import { SearchFilters } from 'src/app/shared/models/search-filters.model';

@Component({
    selector: 'ups-searh-cases',
    templateUrl: './search-cases.component.html',
    styleUrls: ['./search-cases.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchCasesComponent implements AfterViewInit {
  @ViewChild('searchToggle') searchToggle!: ElementRef;

  public defaultLabelSearchCases = 'Search Cases';
  public activeAccordion: string | string[] = '';
  public countries: CatalogItem[] = [];
  public casesType = CasesType;
  public searchReady = false;
  public priorities:CatalogItem[]=[];

  public currentPage: number = 1;
  public totalRecords: number = 1;
  public recordsPerPage: number = 10;
  public latestCaseIdPages: string[] = [];
  public direction: boolean = true;

  public sort: INglDatatableSort = { key: 'createDate', order: 'desc' };

  public filtersForm: FormGroup = new FormGroup({
    casesFrom: new FormControl(this.casesType.ALLCASES),
    country: new FormControl(null),
    priority:new FormControl(null),
    searchText: new FormControl(null),
  });

  public data: FilteredCase[] = [];

  private searchFilters!: SearchFilters;

  constructor(
    private catalogService: CatalogService,
    private spinnerService: SpinnerService,
    private cd: ChangeDetectorRef,
    private casesService: CasesService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngAfterViewInit() {
    this.searchFilters = { ...this.route.snapshot.queryParams } as SearchFilters;
    if (this.searchFilters.casesType) {
      this.searchToggle.nativeElement.click();
      this.filtersForm.patchValue({
        casesFrom: this.searchFilters.casesType,
        country: !this.searchFilters.country ? null : this.searchFilters.country,
        priority: !this.searchFilters.priority ?null: this.searchFilters.priority,
        searchText: this.searchFilters.searchText,
      });
      this.getCases({ updateSearchFilters: false });
    }
  }

  private setTotalCases(numberOfCases: number): void {
    this.totalRecords = numberOfCases ?? this.totalRecords;
  }

  public loadCountries(): void {
    this.spinnerService.show();
    this.catalogService.country().subscribe((countries) => {
      this.countries = countries;
      this.spinnerService.hide();
      this.cd.detectChanges();
    });
  }

  public loadPriorities(): void {
    this.spinnerService.show();
    this.catalogService.priority().subscribe((priorities) => {
      this.priorities = priorities;
      this.spinnerService.hide();
      this.cd.detectChanges();
    });
  }

  public loadCountryPropritydropdowm():void{
    this.loadCountries();
    this.loadPriorities();
  }
  private getCases({ returnTotalCases = false, updateSearchFilters = true } = {}): void {
    if (updateSearchFilters) {
      this.updateSearchFilters(returnTotalCases);
    }

    this.spinnerService.show();

    this.casesService.getCases(this.searchFilters).subscribe({
      next: (response) => {
        this.setResponse(response.cases, response.totalCases);
        this.cd.detectChanges();
      },
      error: (error) => {
        this.spinnerService.hide();
        console.error('Getting the cases filted faild', error);
      },
    });
  }

  private updateSearchFilters(returnTotalCases: boolean): void {
    const currentPage = this.direction ? this.currentPage - 1 : this.currentPage - 2;
    const formValue = this.filtersForm.value;

    this.searchFilters = {
      casesType: formValue.casesFrom,
      country: formValue.country == 'null' ? undefined : formValue.country,
      priority:formValue.priority=='null'? undefined:formValue.priority,
      searchText: formValue.searchText,
      latestCaseId: this.latestCaseIdPages[currentPage],
      recordsPerPage: this.recordsPerPage,
      sortField: this.sort.key,
      sortDirection: this.sort.order,
      returnTotalCases,
    };

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.searchFilters,
      queryParamsHandling: 'merge',
    });
  }

  private setResponse(cases: FilteredCase[], numberOfCases: number = this.totalRecords): void {
    this.searchReady = true;
    this.spinnerService.hide();
    this.data = cases ?? [];
    if (this.data.length > 0) {
      this.latestCaseIdPages[this.currentPage] = this.data[this.data.length - 1].id ?? '';
    }

    this.setTotalCases(numberOfCases);
  }

  public filterCases(): void {
    this.currentPage = 1;
    this.getCases({ returnTotalCases: true });
  }

  public recordsPerPageChange(): void {
    this.currentPage = 1;
    this.getCases();
  }

  public pageChange(direction: boolean): void {
    this.currentPage += direction ? 1 : -1;
    this.getCases();
  }

  onSort($event: INglDatatableSort): void {
    this.sort.key = $event.key;
    this.sort.order = $event.order;
    this.getCases();
  }
}
